// client/src/index.tsx
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";               // <-- App doit être l'export par défaut
import { ErrorBoundary } from "./ErrorBoundary";
import "./index.css";                  // garde si le fichier existe
// client/src/index.tsx (ou App.tsx)
import "./styles/responsive.mobile.scss";

const container = document.getElementById("root");
if (!container) {
  throw new Error("No #root element found");
}
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);